import React, { useState, useEffect } from "react";
import "./ListStyles.css";

import { useNavigate } from "react-router-dom";

import useAxios from "./useAxios";

const TenantsList = ({ logout }) => {
  const navigate = useNavigate();
  const [axios] = useAxios(true, logout);

  const [tenants, setTenants] = useState([]);

  useEffect(() => {
    axios.get("tenants", setTenants);
  }, []);

  return (
    <div className="list-container">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 12,
          marginBottom: 24,
        }}
      >
        <h2 style={{ margin: 0 }}>Tenants</h2>
        <button
          className="edit-button"
          aria-label="Add New Tenant"
          style={{
            fontSize: 24,
            padding: "4px 14px",
            margin: 0,
            lineHeight: 1,
          }}
          onClick={() => navigate("/configuration/tenant/0")}
        >
          +
        </button>
      </div>
      <table className="list-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Domain</th>
            <th>Icon</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {tenants.map((tenant) => (
            <tr key={tenant.id}>
              <td>{tenant.name}</td>
              <td>{tenant.domain}</td>
              <td>{tenant.icon}</td>
              <td>
                <button
                  className="edit-button"
                  onClick={() => navigate("/configuration/tenant/" + tenant.id)}
                >
                  Edit
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TenantsList;
